module.exports = __webpack_public_path__ + "img/20250527_tendencias.e5147abd.jpeg";